module.exports = __webpack_public_path__ + "img/种植贷（对公）.2f1c123e.png";